import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, FormGroup, ControlLabel, FormControl, Glyphicon } from 'react-bootstrap';
import Ace from 'react-ace';
import FlowActions from '../actions/flow';
import SharedSource from '../sources/shared';
import { notificationTypes } from '../constants';
import { addNotification } from '../actions/reduxActions/notification';
import { Notifications } from './notifications/Notifications';
import Model from '../utils/model';
import Loader from './Loader';
import Confirm from './generic/confirm';
import { stringReplace } from '../utils/core';
import translations from '../translations';

import '../../css/macro.less';
import '../../css/notification.less';

import 'brace/mode/javascript';
import 'brace/theme/twilight';

export class MacroEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isNewMacro: false,
            newMacroName: null,
            macros: [],
            showDeleteConfirmation: false,
        };
    }

    componentDidMount() {
        this.getAll(this.props.tenantId, this.props.authenticationToken);
        FlowActions.getActivated(this.props.tenantId);
    }

    onSelected = (e) => {
        const macro = this.state.macros.find(m => m.id === e.target.value);
        this.select(macro);
    }

    onNewMacro = () => {
        const newMacro = {
            code: '',
            developerName: this.state.newMacroName,
            elementType: 'MACRO',
            developerSummary: null,
            id: Model.guid(),
            updateByName: false,
        };
        this.create(newMacro);
        this.setState({ isNewMacro: false, newMacroName: null });
    }

    handleKey = (e) => {
        if (e.keyCode === 13) {
            this.onNewMacro();
        }

        if (e.keyCode === 27) {
            this.onClose();
        }
    }

    onCodeChange = (value) => {
        this.change(value);
    }

    onSave = () => {
        this.save(this.state.selected, this.state.code, this.props.tenantId, this.props.authenticationToken);
    }

    onDelete = () => {
        this.setState({ showDeleteConfirmation: true });
    }

    onConfirmDelete = () => {
        this.delete(
            this.state.selected.id,
            this.props.tenantId,
            this.props.authenticationToken,
        );
    }

    onNameChange = (e) => {
        this.setState({ newMacroName: e.target.value });
    }

    onNew = () => {
        this.setState({ isNewMacro: true });
    }

    onRefresh = () => {
        if (this.state.selected) {
            this.get(this.state.selected.id, this.props.tenantId, this.props.authenticationToken);
        }
    }

    onClose = () => {
        this.setState({ isNewMacro: false, newMacroName: null });
    }

    onLoaded(response) {
        this.setState({
            isLoading: false,
            macros: JSON.parse(response),
        });
    }

    onSaved() {
        this.setState({
            unSavedChanges: false,
            isLoading: false,
        });
        this.props.addNotification({
            type: notificationTypes.SUCCESS,
            message: 'Successfully saved macro!',
        });
    }

    onSaveError(error) {
        this.setState({ isLoading: false });
        this.props.addNotification({
            type: notificationTypes.ERROR,
            message: error.message,
        });
    }

    onDeleted(id) {
        this.setState({
            isLoading: false,
            macros: this.state.macros.filter(macro => macro.id !== id),
            code: null,
            selected: null,
            unSavedChanges: false,
            showDeleteConfirmation: false,
        });

        this.props.addNotification({
            type: notificationTypes.SUCCESS,
            message: 'Successfully deleted macro!',
        });
    }

    onDeleteError(response) {
        this.setState({ isLoading: false });
        this.props.addNotification({
            type: notificationTypes.ERROR,
            message: response.message,
        });
    }

    onRefreshed(macro) {
        const parsedMacro = JSON.parse(macro);
        this.setState({
            code: parsedMacro.code,
            selected: parsedMacro,
            isLoading: false,
            unSavedChanges: false,
        });
    }

    onRefreshError(error) {
        this.setState({ isLoading: false });
        this.props.addNotification({
            type: notificationTypes.ERROR,
            message: error.message,
        });
    }

    getAll(tenantId, authenticationToken) {
        this.setState({ isLoading: true });

        SharedSource.getAll('macro', tenantId, authenticationToken).then((response) => {
            this.onLoaded(response);
        });
    }

    select(macro) {
        this.setState({
            selected: macro,
            code: macro.code,
            unSavedChanges: false,
        });
    }

    create(macro) {
        this.setState({
            macros: [...this.state.macros, macro],
            selected: macro,
            code: null,
            unSavedChanges: false,
        });
    }

    change(code) {
        this.setState({
            code,
            unSavedChanges: true,
        });
    }

    save(macro, code, tenantId, authenticationToken) {

        this.setState({
            isLoading: true,
        });
        macro.code = code;

        SharedSource.save(macro, 'macro', tenantId, authenticationToken)
            .then(response => this.onSaved(response))
            .catch(response => this.onSaveError(response));
    }

    delete(id, tenantId, authenticationToken, callback) {
        this.setState({ isLoading: true });

        SharedSource.delete(id, 'macro', tenantId, authenticationToken)
            .then(() => {
                if (callback) {
                    callback();
                }
                return this.onDeleted(id);
            })
            .catch(response => this.onDeleteError(response));
    }

    get(macroId, tenantId, authenticationToken) {
        this.setState({ isLoading: true });

        SharedSource.get(macroId, 'macro', tenantId, authenticationToken)
            .then((response) => {
                this.onRefreshed(response);
                this.getAll(tenantId, authenticationToken);
            })
            .catch(response => this.onRefreshError(response));
    }

    render() {
        let playerModal = null;
        if (this.state.isNewMacro) {
            playerModal = (
                <Modal show onHide={this.close} container={this.refs.container}>
                    <Modal.Header closeButton>
                        <Modal.Title>New Macro</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormGroup>
                            <ControlLabel>Name</ControlLabel>
                            <FormControl
                                autoFocus
                                onKeyUp={this.handleKey}
                                type="text"
                                value={this.state.newMacroName || ''}
                                onChange={this.onNameChange}
                            />
                        </FormGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.onClose}>Cancel</Button>
                        <Button bsStyle="primary" onClick={this.onNewMacro}>Save</Button>
                    </Modal.Footer>
                </Modal>
            );
        }

        const options = [<option value="" disabled key="select-macro">Select a macro to edit</option>]
            .concat(this.state.macros.map(macro => <option value={macro.id} key={macro.id}>{macro.developerName}</option>));

        const unSavedChanges = this.state.unSavedChanges ? (
            // Shows a persistent notification that cannot be closed when the macro has unsaved changes
            // This notification does not use the global Notifications area but its own instance so that this notification only appears in this tab
            // isPersistent is false so the close button does not appear but this notification will not get cleared
            <Notifications notifications={[
                {
                    type: notificationTypes.INFO,
                    message: 'This macro contains un-saved changes',
                    isPersistent: false,
                },
            ]}
            />
        ) : null;

        return (
            <div className="macro-editor-container" ref="container">
                <div className="macro-header">
                    <div>
                        <FormControl
                            componentClass="select"
                            value={this.state.selected ? this.state.selected.id : ''}
                            onChange={this.onSelected}
                        >
                            {options}
                        </FormControl>
                    </div>
                    <div className="macro-actions">
                        <Button className="new" bsStyle="primary" onClick={this.onNew}>
                            <Glyphicon glyph="plus" />
                            <span>New</span>
                        </Button>
                        <Button className="save" bsStyle="success" onClick={this.onSave} disabled={!this.state.selected}>Save</Button>
                        <Button className="refresh" bsStyle="default" onClick={this.onRefresh} disabled={!this.state.selected}>
                            <Glyphicon glyph="refresh" />
                            <span>Refresh</span>
                        </Button>
                        <Button className="delete" bsStyle="danger" onClick={this.onDelete} disabled={!this.state.selected}>Delete</Button>
                    </div>
                </div>
                <div className="macro-editor">
                    <Ace
                        readOnly={!this.state.selected}
                        mode="javascript"
                        theme="twilight"
                        width="auto"
                        height="auto"
                        name="editor"
                        fontSize={14}
                        onChange={this.onCodeChange}
                        value={this.state.code}
                    />
                    {this.state.isLoading ? <Loader /> : null}
                </div>
                {unSavedChanges}
                {playerModal}
                <Confirm
                    show={this.state.showDeleteConfirmation}
                    title={translations.MACRO_delete_confirmation_title}
                    messages={[
                        stringReplace(translations.MACRO_delete_confirmation_message, {
                            macroName: this.state.selected && this.state.selected.developerName,
                        }),
                        translations.GENERAL_cannot_be_undone,
                    ]}
                    buttonStyle="danger"
                    buttonCaption="Delete"
                    onCancel={() => this.setState({ showDeleteConfirmation: false })}
                    onConfirm={this.onConfirmDelete}
                    isInProgress={this.state.isLoading}
                />
            </div>
        );
    }
}

export default connect(
    ({ currentUser: { authenticationToken, tenantId } }) => ({ authenticationToken, tenantId }),
    { addNotification },
)(MacroEditor);
